/* @flow */
import * as React from 'react';
import memoize from 'memoize-one';
import Spinner from 'components/Spinner';
import ErrorMessage from 'components/ErrorMessage';
import styles from './styles.module.scss';

import type { LiferayError, Translate } from 'types';

type Props = {
  loading?: boolean,
  isVisible?: boolean,
  data?: any,
  error?: LiferayError | { t: Translate },
  render?: any => React$Element<any>,
  fallback?: any => React$Element<any>,
  loadingIsBlocking?: boolean,
  isRenderMemoized?: boolean,
};

class DataLoader extends React.Component<Props> {
  _render = data => {
    const { render } = this.props;
    return typeof render === 'function' ? render(data) : <div />;
  };

  _memoizedRender = memoize(this._render.bind(this));

  render() {
    const {
      loading,
      data,
      error,
      fallback,
      isVisible = true,
      loadingIsBlocking = false,
      isRenderMemoized = false,
    } = this.props;

    if (!isVisible) return null;
    if (data) {
      if (!(loading && loadingIsBlocking)) {
        return isRenderMemoized ? this._memoizedRender(data) : this._render(data);
      }
    }
    if (loading || error) {
      return (
        <div className={styles.centeredContent}>
          {loading && <Spinner />}
          {error && <ErrorMessage {...error} />}
        </div>
      );
    }
    if (typeof fallback === 'function') {
      return fallback();
    }
    return <div />;
  }
}

export default DataLoader;
